<template>
   <layout>
   <div>
	   <!--Nav Bar-->
      <!-- <nav class="navbar navbar-expand-lg fixed-top">
         <div class="container-sm">
            <a class="navbar-brand" href="home.html">
                <img src="/design/sigofood-images/logo.png" alt="icon" style="height:40px;">
            </a>            
         </div>
      </nav> -->

      <!--Map-->
      <div class="location-banner"  style="padding-top: 80px;">
         <div class="banner-caption">
            <h2>Order food online in Bahrain</h2>
            <b-input-group class="mt-3 input-location">
               <template #prepend>
                  <b-input-group-text><img src="/design/sigofood-images/Deliver.png"></b-input-group-text>
               </template>
               <template #append>
                  <b-button class="deliver-here ms-3 py-3 px-4" v-b-modal.location>Go</b-button>
               </template>
               <GmapAutocomplete @place_changed="setPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search your location here.."  :value="location" :options="placesOptions"/>              
                  
            </b-input-group>
         </div>
      </div>

      <section class="download-app mt-5 mb-5">
         <div class="container">
            <div class="row">
               <div class="col-lg-6 app-image">
                  <img src="/design/sigofood-images/mock-screen.jpg" alt="sigofood app">
               </div>
               <div class="col-lg-6 app-text">
                  <div class="">
                     <h4>Download Sigofood app</h4>
                     <p>Order foods from a wide range of restaurants nearby!</p>
                     <div class="app-buttons">
                        <a href="#" class="me-3" target="_blank"><img src="/design/sigofood-images/logo-playstore.png" alt="sigofood playstore"></a>
                        <a href="#" target="_blank"><img src="/design/sigofood-images/logo-appstore.png" alt="sigofood appstore"></a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
        
         
      <b-modal id="location" title="Delivery Location" hide-footer @shown="panToMarker()">
         <form @submit.prevent="onSubmit()">
            <b-input-group class="mt-3 input-location">
               <template #prepend>
                  <b-input-group-text><img src="/design/sigofood-images/Deliver.png"></b-input-group-text>
               </template>
               <GmapAutocomplete @place_changed="setPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here to pick the required latitude and longitude..."  :value="location" :options="placesOptions"/>
            </b-input-group>
            <GmapMap v-if="marker.position.lat && marker.position.lng"
            :center="center"
            :zoom="18"
            map-style-id="roadmap"
            :options="mapOptions"
            style="width: 100%; height: 300px"
            ref="mapRef">                              
               <GmapMarker
               :position="marker.position"
               :clickable="false"
               :draggable="false"                                    
               />
            </GmapMap>   
            
            <div class="mt-3">
               <input type="number" class="form-control form-control-sm py-2" required placeholder="Enter block number" v-model="block_no">
            </div>
            <!-- <div class="mt-3">
               <img src="/design/sigofood-images/Deliver.png"> {{this.location}}
            </div> -->
            <div class="text-center">
               <b-button type="submit" class="mt-3 deliver-here px-5" block>Deliver Here</b-button>
            </div>
         </form>
      </b-modal>
  

   </div>
</layout>
</template>

<script>
import Layout from "@/layout/Main.vue";
export default {	
   components: {
      Layout
   },
	data() {
      return {
      
         token: ""  ,
         fcm: "",
         uid: "",
         latitude: null,
         longitude: null,
         block_no: null,

         marker: { position: { lat: null, lng: null } },
         center: { lat: null, lng: null },
         current_place: null,
         location: "",
         map_place: "",

         mapOptions: {
            disableDefaultUI: true,
            componentRestrictions: {
                country: [
                  'BH',
                ],
            },
         },

         placesOptions: {
            //types: ['(cities)'],
            componentRestrictions: {country: "BH"}
         },

         style: null,
      };      
   },

   created() {
      this.style = document.createElement('link')
      this.style.setAttribute('rel', 'stylesheet')
      this.style.setAttribute('href', '/design/location.css')
      document.head.appendChild(this.style)
   },  

   beforeDestroy() {
      document.head.removeChild(this.style);
   }, 

   mounted() {
      //this.geolocate();
   },
  
   methods: {
      geolocate() {
         navigator.geolocation.getCurrentPosition((position) => {
            this.marker.position = {
                 lat: position.coords.latitude,
                 lng: position.coords.longitude,
            };
            this.center = {
                 lat: position.coords.latitude,
                 lng: position.coords.longitude,
            };
            
         });
      },

      //sets the position of marker when dragged
      handleMarkerDrag(e) {
         this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      },

      //Moves the map view port to marker
      panToMarker() {
         console.log(this.marker.position);
         this.$refs.mapRef.panTo(this.marker.position);
         //this.$refs.mapRef.setZoom(18);
      },

      //Moves the marker to click position on the map
      handleMapClick(e) {
         this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         console.log(e);
      },     

      setPlace(place) {
         this.current_place = place;
         if(this.current_place) {
            const marker = {
               lat: this.current_place.geometry.location.lat(),
               lng: this.current_place.geometry.location.lng(),
            };
            this.center = marker;
            this.marker.position = marker;
            this.map_place = place;
            this.location = place.formatted_address;
            //console.log(place);
         }
      },

      setLocation() {      

         var location = {};
         location.latitude = this.marker.position.lat;
         location.longitude = this.marker.position.lng;
         location.block_no = this.block_no;
         location.place = this.map_place;

         localStorage.setItem('sigofood_location', JSON.stringify(location)); 
         this.$router.push({ name: "home" });
      },

      showModal(modal) {
         this.$refs[modal].show();
      },

      hideModal(modal) {
         this.$refs[modal].hide();
      },
      onSubmit() {
      
         //console.log(data);
         const config = {
            headers: {
              "Content-Type": "multipart/form-data",
              "Accept": "application/json",
            },
         };

         this.errors = {};

         let formData = new FormData();
      	formData.append("block_no", this.block_no);

         this.$axios
         .post("delivery/check", formData, config)
         .then((response) => {
            console.log(response);
            if(response.status == 200) {
               
               var responseData = response.data;
               console.log(responseData);
               if (responseData.status) {
                  var location = {};
                  location.latitude = this.marker.position.lat;
                  location.longitude = this.marker.position.lng;
                  location.block_no = this.block_no;
                  location.place = this.map_place;

                  localStorage.setItem('sigofood_location', JSON.stringify(location)); 
                  this.$router.push({ name: "home" });    
               
               } else {
                  this.$swal("", "Sorry! We don't deliver here", "error");
               }
            }
         })
         .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if (error.response.status == 422) {
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  }
                  this.$swal("", error.response.statusText, "error");
               } else if (error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } else if (error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         });
         //.finally(() => (this.loading = false));
      },
   },
}
</script>
